import React, { lazy } from 'react';
import Tool from '../../shared/components/Tool';
import {
	MUTATION_DELETE_MM_CASE,
	MUTATION_UPDATE_MM_CASE,
} from '../../shared/gql/mutations';
import {
	QUERY_GET_ALL_MM_CASES,
	QUERY_GET_MM_CASE,
} from '../../shared/gql/queries';
import CaseProvider from '../../shared/providers/CaseProvider';

const MietminderungCase = lazy(() => import('./MietminderungCase'));
const Mietminderung = () => (
	<CaseProvider caseMutation={MUTATION_UPDATE_MM_CASE}>
		<Tool
			caseQuery={QUERY_GET_MM_CASE}
			allCasesQuery={QUERY_GET_ALL_MM_CASES}
			deleteMutation={MUTATION_DELETE_MM_CASE}
			partitionKey='A'
		>
			<MietminderungCase />
		</Tool>
	</CaseProvider>
);

export default Mietminderung;
